/**
 * Hue and icon for each staff guide (26 Oct 2026 system-wide refresh, the
 * Bonsai Agents look). Shared by the Guides Library and the reader. A guide
 * added later falls back to indigo and the open book. Hues stay off green,
 * amber and red, which mean status.
 */
import {
  BookOpen, BookMarked, Briefcase, Calculator, Clock, FolderOpen, HeartHandshake, Home, Inbox, ShieldCheck, Sparkles, Spline,
} from "lucide-react";

const LOOK = {
  index: [Spline, "#6366f1", "#8b5cf6"],
  brochure: [Sparkles, "#a855f7", "#ec4899"],
  residential: [Home, "#ec4899", "#a855f7"],
  nonresidential: [Briefcase, "#3b82f6", "#6366f1"],
  "private-client": [HeartHandshake, "#d946ef", "#8b5cf6"],
  admin: [Inbox, "#06b6d4", "#3b82f6"],
  accounts: [Calculator, "#8b5cf6", "#3b82f6"],
  "time-and-payments": [Clock, "#0ea5e9", "#6366f1"],
  "file-opening": [FolderOpen, "#6366f1", "#ec4899"],
  compliance: [ShieldCheck, "#6366f1", "#a855f7"],
  glossary: [BookMarked, "#0ea5e9", "#8b5cf6"],
};
const FALLBACK = [BookOpen, "#6366f1", "#a855f7"];

export function guideLook(key) {
  const [Icon, c1, c2] = LOOK[key] || FALLBACK;
  return { Icon, style: { "--c1": c1, "--c2": c2 } };
}
